import React from "react";
import { FileText, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-12" data-testid="terms-page">
      <div className="container-main max-w-4xl">
        {/* Back Link */}
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-slate-600 hover:text-sky-600 mb-8 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>

        {/* Header */}
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 mb-8">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-sky-500 to-blue-600 flex items-center justify-center">
              <FileText className="w-7 h-7 text-white" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-slate-900 font-['Outfit']">Terms of Service</h1>
              <p className="text-slate-500">Last Updated: March 2026</p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 space-y-8">
          {/* Agreement to Terms */}
          <section>
            <h3 className="text-xl font-semibold text-slate-900 mb-4">1. Agreement to Terms</h3>
            <p className="mb-4 text-slate-600 leading-relaxed">
              By using Bundlecart.au, you agree to be bound by these terms. You must be at least 18 years of age to create an account or use our services.
            </p>
          </section>

          {/* Pricing and Data Accuracy */}
          <section>
            <h3 className="text-xl font-semibold text-slate-900 mb-4">2. Pricing and Data Accuracy (Disclaimer)</h3>
            <p className="mb-4 text-slate-600 leading-relaxed">
              Bundlecart provides grocery price comparisons based on third-party data.
            </p>
            <ul className="list-disc list-inside space-y-3 text-slate-600 ml-4">
              <li>
                <span className="font-medium text-slate-700">Accuracy:</span> Grocery prices and stock levels change rapidly. We do not guarantee that the prices displayed in the app will match the prices in-store at the time of purchase.
              </li>
              <li>
                <span className="font-medium text-slate-700">Liability:</span> Bundlecart is a comparison and delivery facilitation tool. We are not responsible for price discrepancies between the app and the physical retailer.
              </li>
            </ul>
          </section>

          {/* Fees and Subscriptions */}
          <section>
            <h3 className="text-xl font-semibold text-slate-900 mb-4">3. Fees and Subscriptions</h3>
            <ul className="list-disc list-inside space-y-3 text-slate-600 ml-4">
              <li>
                <span className="font-medium text-slate-700">Subscription:</span> The $5 monthly membership grants access to a reduced convenience fee.
              </li>
              <li>
                <span className="font-medium text-slate-700">Convenience Fees:</span>
                <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
                  <li>Members: 4% of order total (capped at $15).</li>
                  <li>Non-Members (Guests): 7% of order total (capped at $15).</li>
                </ul>
              </li>
              <li>
                <span className="font-medium text-slate-700">Delivery Fee:</span> A flat fee of $10 applies to all orders.
              </li>
            </ul>
          </section>

          {/* Prohibited Conduct */}
          <section>
            <h3 className="text-xl font-semibold text-slate-900 mb-4">4. Prohibited Conduct</h3>
            <p className="mb-4 text-slate-600 leading-relaxed">
              We reserve the right to terminate or suspend any account immediately, without notice, if we detect:
            </p>
            <ul className="list-disc list-inside space-y-2 text-slate-600 ml-4">
              <li>Attempted "scraping" or "botting" of our data.</li>
              <li>Fraudulent payment activity.</li>
              <li>Any attempt to reverse-engineer the Bundlecart platform.</li>
            </ul>
          </section>
          
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
